module.exports = __webpack_public_path__ + "static/media/icon-exclamation.21bf0ebc.svg";